var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouponSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .8A.8.8 0 01.8 0h16.4a.8.8 0 01.8.8v2.4c-.078.357-.334.547-.59.737-.305.226-.61.452-.61.963 0 .573.383.885.72 1.16.216.175.413.336.48.54v2.2a.8.8 0 01-.8.8H.8a.8.8 0 01-.8-.8V6.6c.078-.357.334-.547.59-.737.305-.226.61-.452.61-.963 0-.573-.383-.885-.72-1.16C.264 3.565.067 3.404 0 3.2V.8z",
    fill: "url(#coupon-small_svg__paint0_linear_465_3853)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.8.2a.6.6 0 00-.6.6v2.364a.612.612 0 00.128.178c.075.077.168.154.278.243l.016.013c.328.267.778.634.778 1.302 0 .3-.092.528-.232.71-.132.171-.303.299-.45.407l-.01.007c-.256.19-.443.337-.508.599V8.8a.6.6 0 00.6.6h16.4a.6.6 0 00.6-.6V6.636a.61.61 0 00-.128-.178 3.228 3.228 0 00-.278-.243l-.016-.013c-.328-.267-.778-.634-.778-1.302 0-.301.092-.528.232-.71.132-.171.303-.299.45-.407l.01-.007c.256-.19.443-.337.508-.599V.8a.6.6 0 00-.6-.6H.8zm17.2 3V.8a.8.8 0 00-.8-.8H.8a.8.8 0 00-.8.8v2.4c.067.204.264.365.48.54.337.275.72.587.72 1.16 0 .511-.305.737-.61.963-.256.19-.512.38-.59.737v2.2a.8.8 0 00.8.8h16.4a.8.8 0 00.8-.8V6.6c-.067-.204-.264-.365-.48-.54-.337-.275-.72-.587-.72-1.16 0-.511.305-.737.61-.963.256-.19.512-.38.59-.737z",
    fill: "#0F8278",
    fillOpacity: 0.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 2.3a.5.5 0 01.5-.5h10.407a.5.5 0 010 1H3.7a.5.5 0 01-.5-.5zM3.2 7.102a.5.5 0 01.5-.5h10.407a.5.5 0 010 1H3.7a.5.5 0 01-.5-.5z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coupon-small_svg__paint0_linear_465_3853",
    x1: 0.3,
    y1: 0.4,
    x2: 17.7,
    y2: 9.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26BAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148E84"
  })))));
}
export default SvgCouponSmall;